import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TenantUser, TenantUserList } from '../../_objects/user';

import { ApiService } from '../base/api-base.service';
import { TenantUserContractService } from '../interfaces/tenant-user-contract.service';
import { NetworkStatusService } from '../network-status.service';
import { TenantUserOfflineService } from '../offline/tenant-user-offline.service';
import { TenantUserOnlineService } from '../online/tenant-user-online.service';

@Injectable()
export class TenantUserService extends ApiService<TenantUserContractService> implements TenantUserContractService {

  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: TenantUserOfflineService,
    protected onlineService: TenantUserOnlineService) {
    super(networkStatusService, offlineService, onlineService);
  }

  // TN01 GET /api/v1/users
  getUsers(): Observable<TenantUserList[]> {
    return this.service.getUsers();
  }
  // TN02 GET /api/v1/users/{userId}
  getUser(id: string): Observable<TenantUser> {
    return this.service.getUser(id);
  }
}
